import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconClockAlternative16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconClockAlternative16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0m1 0A7 7 0 1 1 1 8a7 7 0 0 1 14 0m-8.354-.647-1.33-1.289a.5.5 0 0 1 .695-.718l1.343 1.3a1.5 1.5 0 0 1 1.325.016l2.026-1.96a.5.5 0 1 1 .695.72L9.369 7.386a1.5 1.5 0 1 1-2.722-.033M8.5 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconClockAlternative16);
